import { Download } from "lucide-react";

import {
  AttachmentType,
  SupportRequestAttachment,
} from "@/app/entities/SupportRequest";
import { handleDownload } from "@/app/utils/download";
import { withCdn } from "@/app/utils/withCdn";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/view/components/ui/dialog";

interface AttachmentViewerProps {
  attachment: SupportRequestAttachment | null;
  onClose: () => void;
}

// Visualiza imagens (e vídeos) do chamado na própria tela, sem baixar nem abrir outra aba.
export const AttachmentViewer = ({
  attachment,
  onClose,
}: AttachmentViewerProps) => (
  <Dialog open={!!attachment} onOpenChange={(open) => !open && onClose()}>
    <DialogContent
      showSupportButton={false}
      classNameCloseIcon="text-white"
      className="flex max-h-[92vh] w-auto max-w-[95vw] flex-col items-center gap-3 border-0 bg-black/90 p-3 pt-12 sm:max-w-[90vw] sm:rounded-xl"
    >
      <DialogTitle className="sr-only">
        {attachment?.name ?? "Anexo"}
      </DialogTitle>
      <DialogDescription className="sr-only">
        Visualização do anexo do chamado
      </DialogDescription>

      {attachment?.type === AttachmentType.VIDEO ? (
        <video
          src={withCdn(attachment.url)}
          controls
          autoPlay
          className="max-h-[70vh] max-w-full rounded-md"
        />
      ) : (
        attachment && (
          <img
            src={withCdn(attachment.url)}
            alt={attachment.name}
            className="max-h-[70vh] max-w-full rounded-md object-contain"
          />
        )
      )}

      {attachment && (
        <button
          type="button"
          onClick={() =>
            handleDownload({
              url: withCdn(attachment.url),
              name: attachment.name,
            })
          }
          className="flex items-center gap-2 rounded-lg border border-white/40 px-3 py-1.5 text-xs font-semibold text-white hover:bg-white/10"
        >
          <Download className="h-4 w-4" />
          Baixar
        </button>
      )}
    </DialogContent>
  </Dialog>
);
